import * as fpjs from '@fingerprintjs/fingerprintjs';

// Initialize FingerprintJS with a singleton pattern
let fpPromise: Promise<fpjs.Agent> | null = null;

export async function getDeviceId(): Promise<string> {
  try {
    // Initialize FingerprintJS only once
    if (!fpPromise) {
      fpPromise = fpjs.load();
    }

    // Get the agent instance
    const fp = await fpPromise;
    
    // Get the visitor identifier
    const result = await fp.get();
    
    // Return the visitor ID as our device identifier
    return result.visitorId;
  } catch (error) {
    console.error('Error getting device fingerprint:', error);
    // Fallback to a random identifier if fingerprinting fails
    return `fallback-${Math.random().toString(36).substring(2)}`;
  }
}

// Get the components used in fingerprinting
export async function getFingerprintComponents(): Promise<Record<string, any>> {
  try {
    if (!fpPromise) {
      fpPromise = fpjs.load();
    }
    
    const fp = await fpPromise;
    const components = await fp.get({ extendedResult: true });
    
    return {
      userAgent: components.components.userAgent,
      platform: components.components.platform,
      screenResolution: components.components.screenResolution,
      timezone: components.components.timezone,
      languages: components.components.languages,
      cpu: components.components.cpu,
      deviceMemory: components.components.deviceMemory,
      hardwareConcurrency: components.components.hardwareConcurrency,
      canvas: components.components.canvas,
      webgl: components.components.webgl,
      webglVendor: components.components.webglVendor,
      touchSupport: components.components.touchSupport,
      vendor: components.components.vendor,
      vendorFlavors: components.components.vendorFlavors
    };
  } catch (error) {
    console.error('Error getting fingerprint components:', error);
    return {};
  }
}